import {
  CashAccountLiteModel,
  useGetCashAccounts,
} from 'api-hooks/cash-account';
import { NavigationRoutes } from 'common/constants';
import { string2money } from 'common/utils/string';
import { IColumn } from 'components/elements/table-component/table-component';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useGetListParamsValue from 'hooks/use-get-list-params-value';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import UniskaiListTemplate from 'templates/list/uniskai-list-template';

export default function CashAccountList() {
  const { t } = useTranslation();
  const { queryPage } = useGetListParamsValue();
  const [page, setPage] = React.useState(queryPage);
  const columns = React.useMemo<IColumn<CashAccountLiteModel>[]>(
    () => [
      {
        header: t('common:code'),
        accessorKey: 'code',
        minSize: 150,
        sortName: 'code',
      },
      {
        header: t('common:name'),
        accessorKey: 'name',
        minSize: 150,
        sortName: 'name',
      },
      {
        header: t('common:description'),
        accessorKey: 'description',
        minSize: 250,
        sortName: 'description',
      },
      {
        header: t('common:balance'),
        accessorKey: 'balance',
        sortName: 'balance',
        minSize: 100,
        cell: ({ getValue }) => <>{string2money(getValue() as string)}</>,
      },
    ],
    [t],
  );

  const permission = useGetCrudPermission('cash-accounts');
  return (
    <UniskaiListTemplate
      columns={columns}
      addNavigation={NavigationRoutes.CashAccountsCreate}
      page={page}
      setPage={setPage}
      tableName={NavigationRoutes.CashAccountsList}
      title={t(`pathname:${NavigationRoutes.CashAccountsList}`)}
      useQuery={useGetCashAccounts}
      queryInput={{
        params: {
          page,
        },
      }}
      showAdd={permission.create}
      rowLink={
        permission.view
          ? (row) => ({
              pathname: NavigationRoutes.CashAccountsView,
              query: { id: row.original.id },
            })
          : undefined
      }
    />
  );
}
